<template>
  <table class="level-decrements-table table table-bordered text-nowrap">
    <thead class="thead-dark">
      <tr>
        <th rowspan="2">Время</th>
        <th rowspan="2">Игрок</th>
        <th rowspan="2" class="text-right">Ид</th>
        <th colspan="3" class="text-center">Уровень</th>
        <th rowspan="2">
          <span v-b-popover.hover.top.html="'Уменьшения уровня (УУ)<br>одного игрока'">
            УУ игрока
          </span>
        </th>
      </tr>
      <tr>
        <th class="text-right">старый</th>
        <th class="text-right">новый</th>
        <th class="text-right">разность</th>
      </tr>
    </thead>
    <tr
      v-for="levelDecrement in levelDecrements"
      :key="getLevelDecrementKey(levelDecrement)"
    >
      <td>{{ getMomentStr(levelDecrement.ctime) }}</td>
      <td>
        <player-link :playerId="levelDecrement.playerId" label="игрок"/>
      </td>
      <td class="text-right">{{ levelDecrement.id }}</td>
      <td class="text-right">{{ getFormattedNumber(levelDecrement.oldLevel) }}</td>
      <td class="text-right">{{ getFormattedNumber(levelDecrement.newLevel) }}</td>
      <td class="text-right">{{ getLevelDifferenceStr(levelDecrement) }}</td>
      <td>
        <router-link
          :to="{name: 'player_level_decrements', params: {playerId: levelDecrement.playerId}}"
        >УУ игрока</router-link>
      </td>
    </tr>
  </table>
</template>

<script>
import { getLevelDifference } from '../../model/level_decrement.js';
import { getMomentStr       } from '../../util.js';
import { getFormattedNumber } from '../../util.js';

import PlayerLink from '../PlayerLink.vue';

export default {
  name: 'LevelDecrementsTable',

  components: {
    PlayerLink,
  },

  props: {
    levelDecrements: {
      type: Array,
      required: true,
    },
  },

  methods: {
    getLevelDecrementKey(levelDecrement) {
      const playerIdStr = levelDecrement.playerId.toString();
      const idStr = levelDecrement.id.toString();
      return playerIdStr + '_' + idStr;
    },

    getLevelDifferenceStr(levelDecrement) {
      const levelDifference = getLevelDifference(levelDecrement);
      return getFormattedNumber(levelDifference);
    },

    getMomentStr,
    getFormattedNumber,
  },
};
</script>

<style scoped>
.level-decrements-table {
  max-width: 1px;
}
</style>
